import { IsoToDateTimeAccordingToIndia } from "../../../CommonFunction/IsoDateTime";

const prepareChartDataOne = (data, colors) => {
  const dates = [];
  const datasets = {};

  data?.forEach((dateObj) => {
    const dateKey = Object.keys(dateObj)[0];
    const date = dateKey;
    dates.push(date);
    dateObj[dateKey].loads.forEach((load) => {
      if (!datasets[load.Full_Name]) {
        datasets[load.Full_Name] = {
          label: load.Full_Name,
          data: [],
          borderColor: colors[load.Full_Name],
          fill: false,
        };
      }
      while (datasets[load.Full_Name].data.length < dates.length - 1) {
        datasets[load.Full_Name].data.push(0);
      }
      datasets[load.Full_Name].data.push(load.count);
    });

    Object.keys(datasets).forEach((key) => {
      if (datasets[key].data.length < dates.length) {
        datasets[key].data.push(0);
      }
    });
  });

  return {
    labels: dates,
    datasets: Object.values(datasets),
  };
};

const prepareChartDataTwo = (data, color, label) => {
  const dates = [];
  const totalsByDate = {};
  const detailsByDate = {};

  data?.forEach((dateObj) => {
    const dateKey = Object.keys(dateObj)[0];
    const date = dateKey;
    dates.push(date);
    totalsByDate[date] = 0;
    detailsByDate[date] = [];

    dateObj[dateKey].loads.forEach((load) => {
      totalsByDate[date] += load.count;
      detailsByDate[date].push(`${load.Full_Name}: ${load.count}`);
    });
  });

  const dataset = {
    label: label,
    data: dates.map((date) => totalsByDate[date]),
    borderColor: color,
    fill: false,
  };

  return {
    labels: dates,
    datasets: [dataset],
    tooltips: dates.map((date) => detailsByDate[date].join("\n")),
  };
};

const prepareChartDataForAppDownloadsTwo = (data, color, label) => {
  const dates = [];
  const totalsByDate = {};
  const detailsByDate = {};

  data?.forEach((dateObj) => {
    const dateKey = Object.keys(dateObj)[0];
    const date = dateKey;
    dates.push(date);
    totalsByDate[date] = 0;
    detailsByDate[date] = [];

    dateObj[dateKey].Downloads.forEach((load) => {
      const totalCount = load.ios + load.android;
      totalsByDate[date] += totalCount;
      detailsByDate[date].push(`iOS: ${load.ios}`);
      detailsByDate[date].push(`Android: ${load.android}`);
    });
  });

  const dataset = {
    label: label,
    data: dates.map((date) => totalsByDate[date]),
    borderColor: color,
    fill: false,
  };

  return {
    labels: dates,
    datasets: [dataset],
    tooltips: dates.map((date) => detailsByDate[date].join("\n")),
  };
};

const prepareChartDataForAppDownloadsOne = (data, colors) => {
  const dates = [];
  const iosData = [];
  const androidData = [];
  // console.log(data, "UUUUUUUUUUUPOKHKHKJ")
  data?.forEach((dateObj) => {
    const dateKey = Object.keys(dateObj)[0];
    const date = dateKey;
    dates.push(date);

    let iosTotal = 0;
    let androidTotal = 0;

    dateObj[dateKey].Downloads.forEach((download) => {
      iosTotal += download.ios;
      androidTotal += download.android;
    });

    iosData.push(iosTotal);
    androidData.push(androidTotal);
  });

  return {
    labels: dates,
    datasets: [
      {
        label: "iOS Downloads",
        data: iosData,
        borderColor: "#FF8A65",
        fill: false,
      },
      {
        label: "Android Downloads",
        data: androidData,
        borderColor: "#7BDCB5",
        fill: false,
      },
    ],
  };
};

const prepareChartDataForUserActivityOne = (data) => {
  const dates = [];
  const iosData = [];
  const androidData = [];

  const timePeriods = Object.keys(data[0]);

  timePeriods.forEach((period) => {
    dates.push(period);
    iosData.push(data[0][period].totalIosUserCount);
    androidData.push(data[0][period].totalAndroidUserCount);
  });

  return {
    labels: dates,
    datasets: [
      {
        label: "IOS Activity",
        data: iosData,
        borderColor: "#FF8A65",
        fill: false,
      },
      {
        label: "Android Activity",
        data: androidData,
        borderColor: "#7BDCB5",
        fill: false,
      },
    ],
  };
};

const prepareChartDataForUserActivityTwo = (data, color, label) => {
  const dates = [];
  const totalsByDate = {};
  const detailsByDate = {};

  const timePeriods = Object.keys(data[0]);

  timePeriods.forEach((period) => {
    dates.push(period);
    const iosCount = data[0][period].totalIosUserCount;
    const androidCount = data[0][period].totalAndroidUserCount;

    totalsByDate[period] = iosCount + androidCount;
    detailsByDate[period] = [`IOS Activity: ${iosCount}`, `Android Activity: ${androidCount}`];
  });

  const dataset = {
    label: label,
    data: dates.map((date) => totalsByDate[date]),
    borderColor: color,
    fill: false,
  };

  return {
    labels: dates,
    datasets: [dataset],
    tooltips: dates.map((date) => detailsByDate[date].join("\n")),
  };
};

function processUserActivityData(data) {
  const timePeriods = Object.keys(data[0]);

  const updatedData = timePeriods.map((period) => {
    const iosCount = data[0][period].totalIosUserCount || 0;
    const androidCount = data[0][period].totalAndroidUserCount || 0;

    return {
      _id: Math.random(),
      Time_Range: period,
      IOS_User_Activity: iosCount,
      Android_User_Activity: androidCount,
    };
  });

  return updatedData;
}

// function processUserActivityDataForIndividualApproach(data) {
//   const timePeriods = Object.keys(data[0]);
//   const updatedData = [];

//   let arr = []
//   timePeriods.forEach((period) => {
//     const periodData = data[0][period] || {};
//     const totalsByMedium = {};
//     Object.keys(periodData).forEach((medium) => {

//       if (!arr.includes(medium)) {
//         arr.push(medium)
//       }
//       const mediumData = periodData[medium] || { totalIosUserCount: 0, totalAndroidUserCount: 0 };
//       const totalIosUserCount = mediumData.totalIosUserCount || 0;
//       const totalAndroidUserCount = mediumData.totalAndroidUserCount || 0;

//       totalsByMedium[medium] =
//         totalIosUserCount + totalAndroidUserCount

//     });

//     updatedData.push({
//       _id: Math.random(),
//       Time_Range: period,
//       ...totalsByMedium
//     });
//     console.log(totalsByMedium)
//   });
//   return { ColAddition: arr, updatedData };
// }

function processUserActivityDataForIndividualApproach(data) {
  const timePeriods = Object.keys(data[0]);  // Extract time periods from the first item
  let mediums = new Set();  // Use a Set to collect unique mediums

  // Initialize an object to hold the final reformatted data
  const reformattedData = {};

  timePeriods.forEach((period) => {
    const periodData = data[0][period] || {};  // Safely access the data for the period

    Object.keys(periodData).forEach((medium) => {
      mediums.add(medium);  // Add the medium to the set

      const mediumData = periodData[medium] || { totalIosUserCount: 0, totalAndroidUserCount: 0 };
      const totalUsers = (mediumData.totalIosUserCount || 0) + (mediumData.totalAndroidUserCount || 0);

      // Ensure an object exists for the medium and set up the period with the total users
      if (!reformattedData[medium]) {
        reformattedData[medium] = {};
      }
      reformattedData[medium][period] = totalUsers;
    });
  });

  // Create a list from the set of mediums
  const mediumsList = Array.from(mediums);

  // Prepare the final array of data
  const updatedData = mediumsList.map(medium => {
    const dataForMedium = { _id: Math.random(), Medium: medium };
    timePeriods.forEach(period => {
      dataForMedium[period] = reformattedData[medium][period] || 0;  // Fill in zeroes where no data exists
    });
    return dataForMedium;
  });

  return { updatedData };
}


const prepareChartDataForUserActivityOneForIndividualApproach = (data) => {
  const labels = Object.keys(data[0]);
  const mediums = new Set();

  labels.forEach((period) => {
    const periodData = data[0][period];
    Object.keys(periodData).forEach((medium) => {
      mediums.add(medium);
    });
  });

  const colorMap = {
    Hording: "#FF5733",
    Poster: "#33FF57",
    Pamphlet: "#3357FF",
    Others: "#FF33A1",
  };

  const datasets = Array.from(mediums).map((medium) => ({
    label: `${medium} Activity`,
    data: labels.map(
      (period) =>
        data[0][period][medium]?.totalIosUserCount +
        data[0][period][medium]?.totalAndroidUserCount || 0
    ),
    borderColor: colorMap[medium] || "#000000",
    fill: false,
  }));

  return {
    labels, // Time periods
    datasets,
  };
};

const prepareChartDataForUserActivityTwoForIndividualApproach = (data, colorMap) => {
  const dates = [];
  const mediumTotalsByDate = {};
  const detailsByDate = {};
  const totalActivityByDate = {};

  const timePeriods = Object.keys(data[0]);
  const mediums = Object.keys(data[0].today);

  timePeriods.forEach((period) => {
    dates.push(period);
    detailsByDate[period] = [];
    totalActivityByDate[period] = 0;

    mediums.forEach((medium) => {
      const mediumData = data[0][period][medium] || { totalIosUserCount: 0, totalAndroidUserCount: 0 };
      const total = mediumData.totalIosUserCount + mediumData.totalAndroidUserCount;

      if (!mediumTotalsByDate[medium]) {
        mediumTotalsByDate[medium] = {};
      }
      mediumTotalsByDate[medium][period] = total;
      detailsByDate[period].push(`${medium}: ${total}`);
      totalActivityByDate[period] += total;
    });
  });

  const datasets = [{
    label: 'Total Activity',
    data: dates.map((date) => totalActivityByDate[date]),
    borderColor: "#000000",
    fill: false,
  }];

  return {
    labels: dates,
    datasets: datasets,
    tooltips: dates.map((date) => detailsByDate[date].join("\n")),
  };
};

function processDataForDWMLoads(data) {
  console.log(data);

  const allNamesSet = new Set();

  // Collect all unique Full_Names
  data.forEach((dailyData) => {
    const date = Object.keys(dailyData)[0];
    dailyData[date].loads.forEach((load) => {
      allNamesSet.add(load.Full_Name);
    });
  });

  // colAddition: single date header + names
  const colAddition = [
    ["date", "date", null],
    ...Array.from(allNamesSet).map((name) => [name, name, name])
  ];

  // updatedData as before
  const updatedData = data.map((dailyData) => {
    const date = Object.keys(dailyData)[0];

    return {
      _id: Math.random(10),
      date,
      ...Array.from(allNamesSet).reduce(
        (obj, name) => ({
          ...obj,
          [name]: dailyData[date].loads.find((load) => load.Full_Name === name)?.count || 0,
        }),
        {}
      ),
    };
  });

  console.log(colAddition);
  return { colAddition, updatedData };
}



function processLoadData(data) {
  const allNames = new Set();
  const allDates = new Set();

  data.forEach((dailyData) => {
    const date = Object.keys(dailyData)[0];
    allDates.add(date);
    dailyData[date].loads.forEach((load) => allNames.add(load.Full_Name));
  });

  const updatedData = Array.from(allNames).map((name) => {
    const row = { _id: Math.random(10), Full_Name: name };

    Array.from(allDates).forEach((date) => {
      const dailyData = data.find((entry) => Object.keys(entry)[0] === date);
      const count = dailyData[date].loads.find((load) => load.Full_Name === name)?.count || 0;
      row[date] = count;
    });
    // console.log(allNames, allDates, row)
    return row;
  });

  return { ColAddition: [...allDates], updatedData };
}

function processDownloadData(data) {
  const allPlatforms = new Set(["ios", "android"]);

  const updatedData = data.map((dailyData) => {
    const date = Object.keys(dailyData)[0];

    return {
      _id: Math.random(),
      date,
      ...Array.from(allPlatforms).reduce(
        (obj, platform) => ({
          ...obj,
          [platform]: dailyData[date].Downloads[0][platform] || 0,
        }),
        {}
      ),
    };
  });

  return { ColAddition: [...allPlatforms], updatedData };
}

const prepareChartDataForPageActivityOne = (data) => {
  const dates = [];
  const datasets = {};

  data?.forEach((dateObj) => {
    const dateKey = Object.keys(dateObj)[0];
    dates.push(dateKey);

    const dateData = dateObj[dateKey];

    Object.keys(dateData).forEach((key) => {
      if (!datasets[key]) {
        datasets[key] = {
          label: key.replace(/_/g, " "),
          data: [],
          borderColor: getColorForKey(key),
          fill: false,
        };
      }
      datasets[key].data.push(dateData[key] || 0);
    });

    Object.keys(datasets).forEach((key) => {
      if (!dateData[key]) datasets[key].data.push(0);
    });
  });

  return {
    labels: dates,
    datasets: Object.values(datasets),
  };
};

const prepareChartDataForPageActivityTwo = (data, color, label) => {
  const dates = [];
  const totalsByDate = {};
  const detailsByDate = {};

  data?.forEach((dateObj) => {
    const dateKey = Object.keys(dateObj)[0];
    const dateData = dateObj[dateKey];
    dates.push(dateKey);

    totalsByDate[dateKey] = 0;
    detailsByDate[dateKey] = [];

    Object.keys(dateData).forEach((key) => {
      const count = dateData[key] || 0;
      totalsByDate[dateKey] += count;
      detailsByDate[dateKey].push(`${formatLabel(key)}: ${count}`);
    });
  });

  return {
    labels: dates,
    datasets: [
      {
        label: label,
        data: dates.map((date) => totalsByDate[date]),
        borderColor: color,
        fill: false,
      },
    ],
    tooltips: dates.map((date) => detailsByDate[date].join("\n")),
  };
};

function processPageActivityData(data) {
  const allMetrics = new Set();
  const allDates = new Set();

  // Collect all unique metrics and dates
  data.forEach((dailyData) => {
    const date = Object.keys(dailyData)[0];
    allDates.add(date);

    const activityData = dailyData[date] || {};
    Object.keys(activityData).forEach((key) => allMetrics.add(key));
  });

  // Convert metrics and dates to arrays
  const metricsArray = Array.from(allMetrics);
  const datesArray = Array.from(allDates);

  // Map metrics as row headers and fill date columns with corresponding values
  const updatedData = metricsArray.map((metric) => {
    const row = { _id: Math.random(), metric: metric.replace(/_/g, " ") };

    datesArray.forEach((date) => {
      const dailyData = data.find((entry) => Object.keys(entry)[0] === date);
      const activityData = dailyData[date] || {};
      row[date] = activityData[metric] !== undefined ? activityData[metric] : 0;
    });

    return row;
  });

  return { ColAddition: [...allDates], updatedData };
}

function processPageActivityTableData(data) {
  let activitySet = new Set();

  let updatedData = data.map((entry) => {
    const { _id, Full_Name, Activity } = entry;
    const row = { _id, Accounts: Full_Name };

    Object.keys(Activity).forEach((activityKey) => {
      activitySet.add(activityKey);

      row[activityKey] = activityKey === "date"
        ? IsoToDateTimeAccordingToIndia(Activity[activityKey])
        : Activity[activityKey];
    });

    return row;
  });

  // Build ColAddition as desired
  const colAddition = [
    ["Accounts", "Accounts", null],
    ["date", "date", null],
    ...Array.from(activitySet)
      .filter(key => key !== "date")
      .map(key => [key, key, key])
  ];

  console.log(colAddition, updatedData);
  return { ColAddition: colAddition, updatedData };
}


export {
  prepareChartDataOne,
  prepareChartDataTwo,
  processDataForDWMLoads,
  processLoadData,
  prepareChartDataForAppDownloadsTwo,
  prepareChartDataForAppDownloadsOne,
  processDownloadData,
  prepareChartDataForPageActivityOne,
  prepareChartDataForPageActivityTwo,
  processPageActivityData,
  processPageActivityTableData,
  prepareChartDataForUserActivityOne,
  prepareChartDataForUserActivityTwo,
  processUserActivityData,
  prepareChartDataForUserActivityOneForIndividualApproach,
  prepareChartDataForUserActivityTwoForIndividualApproach,
  processUserActivityDataForIndividualApproach
};

const getColorForKey = (key) => {
  const colors = {
    Truck_Posts_Count: "#FF8A65",
    Load_Posts_Count: "#7BDCB5",
    My_Tracking_count: "#FFD700",
    SP_View_Count: "#4682B4",
    Toll_And_Fuel_Count: "#8A2BE2",
    Call_SP_Count: "#FF4500",
    Call_LP_Count: "#32CD32",
  };

  return colors[key] || "#000000";
};

export function getRandomColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

const formatLabel = (key) => {
  return key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};
